(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus/assets/javascripts/views/content/activesuspension.js') >= 0) return;  svs.modules.push('/modules/spelpaus/assets/javascripts/views/content/activesuspension.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.spelpaus.views.ActiveSuspension = Marionette.View.extend({
    template: function(data) {
      return svs.spelpaus.templates.activesuspension(data);
    },
    modelEvents: {
      change: 'render'
    }
  });
})(Backbone, _, svs);

 })(window);